import { CompletedOrdersTab, WaitingOrdersTab } from "./Orders.tsx";
import Report from "./Report";
import AdminOrdersContext, {
  AdminOrdersProvider,
} from "context/AdminOrdersContext.tsx";
import { useContext } from "react";
import UserContext from "context/UserContext";

export default function AdminOrder({ pageName }) {
  const { orders, setOrders } = useContext(AdminOrdersContext);
  const { superAdminOrders, customerOrders } = useContext(UserContext);
  let title;
  superAdminOrders
    ? (title = ["سفارشات درحال انتظار", "سفارشات تکمیل شده", "گزارش"])
    : (title = ["سفارشات درحال انتظار", "سفارشات تکمیل شده"]);
  let components = [
    <WaitingOrdersTab
      orders={orders.filter((value) => value.lats_order_status != 4)}
      pageName={pageName}
    />,
    <CompletedOrdersTab
      orders={orders.filter((value) => value.lats_order_status == 4)}
    />,
    <Report />,
  ];
  console.log("****", superAdminOrders, customerOrders);
  return (
    <div>
      <ul className=" nav nav-tabs mb-3" id="tabs-tab" role="tablist">
        {title.map((value, index) => (
          <li className="nav-item mx-4" role="presentation">
            <button
              className={`title  nav-link${index == 0 ? " active" : ""}`}
              id={`nav-${index}-tab`}
              data-bs-toggle="tab"
              data-bs-target={`#tabs-${index}`}
              type="button"
              role="tab"
              aria-controls={`tabs-${index}`}
              aria-selected="true"
              key={`admin-panel-tab-buttons-${index}`}
            >
              {value}
            </button>
          </li>
        ))}
      </ul>
      <div className="body tab-content">
        {components.map((value, index) => (
          <div
            class={`tab-pane fade${index == 0 ? " show active" : ""}`}
            id={`tabs-${index}`}
            role="tabpanel"
            aria-labelledby={`nav-${index}-tab`}
            key={`admin-panel-tabs-${index}`}
          >
            {value}
          </div>
        ))}
      </div>
    </div>
  );
}
